/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const colorGreen = token('color.text.accent.green');
const colorRed = token('color.text.accent.red');
const colorBlue = token('color.text.accent.blue');
const colorYellow = token('color.text.accent.yellow');
const colorWarning = token('color.background.warning.bold');
const backgroundColorGreen = token('color.background.accent.green.subtlest');
const backgroundColorRed = token('color.background.accent.red.subtlest');
const backgroundColorBlue = token('color.background.accent.blue.subtlest');
const backgroundColorYellow = token('color.background.accent.yellow.subtlest');

const space0 = token('space.0');
const space50 = token('space.050');
const space75 = token('space.075');
const space100 = token('space.100');
const space150 = token('space.150');
// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
const borderRadius = token('border.radius', '3px');

export const FileNumber = styled.span({
  fontWeight: token('font.weight.bold'),
});

export const IconContainer = styled.div({
  position: 'relative',
});

export const ConflictIndicator = styled.span({
  backgroundColor: colorWarning,
  borderRadius: space100,
  height: space100,
  left: '28px',
  position: 'absolute',
  top: space100,
  width: space100,
});

export const ErrorWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
});

export const LinesUpdatedPanel = styled.div({
  padding: `${space50} ${space100} ${space0} ${space75}`,
  marginLeft: space75,
});

export const LinesUpdatedBody = styled.div({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '> div:last-of-type': {
    display: 'flex',
    flexShrink: 0,
    overflow: 'hidden',
  },
});

export const LinesUpdatedLabel = styled.span({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '& h5': {
    color: token('color.text.subtle'),
  },
});

export const LinesUpdatedIcons = styled.div({
  marginLeft: 'auto',
  height: '100%',
  alignItems: 'center',
  padding: `${space0} ${space50} ${space0} ${space150}`,
});

export const LinesAdded = styled.span<{
  cutCorners: boolean;
  isColorBlindMode: boolean;
}>`
  margin-top: 0;

  ${({ cutCorners, isColorBlindMode }) => {
    let baseStyling = ``;
    baseStyling = isColorBlindMode
      ? `background-color: ${backgroundColorBlue};
        & span {
           color: ${colorBlue};
        }`
      : `background-color: ${backgroundColorGreen};
        & span {
          color: ${colorGreen};
        }`;

    baseStyling = cutCorners
      ? `${baseStyling} border-radius: ${borderRadius} 0px 0px ${borderRadius};`
      : `${baseStyling} border-radius: ${borderRadius};`;

    baseStyling = `${baseStyling} padding: 3px 4px;`;
    return baseStyling;
  }}
`;

export const LinesRemoved = styled.span<{
  cutCorners: boolean;
  isColorBlindMode: boolean;
}>`
  margin-top: 0;

  ${({ cutCorners, isColorBlindMode }) => {
    let baseStyling = ``;
    baseStyling = isColorBlindMode
      ? `background-color: ${backgroundColorYellow};
      & span {
           color: ${colorYellow};}`
      : `background-color: ${backgroundColorRed};
      & span {
           color: ${colorRed};}`;

    baseStyling = cutCorners
      ? `${baseStyling} border-radius: 0px ${borderRadius} ${borderRadius} 0px;`
      : `${baseStyling} border-radius: ${borderRadius};`;

    baseStyling = `${baseStyling} padding: 3px 4px;`;
    return baseStyling;
  }}
`;
